export const MAIN_HOME_WIDGET_TEST_IDS = {
  // ─── Widget Container ───
  widgetContainer: 'main-home-widget-container',

  // ─── Widget Navigation (Desktop) ───
  desktopNavigation: 'main-home-widget-desktop-navigation',
  desktopNavTab: (tabId: string) => `main-home-widget-desktop-nav-tab-${tabId}`,

  // ─── Widget Navigation (Mobile) ───
  mobileNavigation: 'main-home-widget-mobile-navigation',
  mobileNavTab: (tabId: string) => `main-home-widget-mobile-nav-tab-${tabId}`,

  // ─── Search Smart Container ───
  searchSmartContainer: 'main-home-widget-search-smart-container',
  searchSmartTab: (tabType: string) => `main-home-widget-search-smart-tab-${tabType}`,
  searchSmartTabContent: (tabType: string) => `main-home-widget-search-smart-content-${tabType}`,

  // ─── Loading Skeleton ───
  loadingSkeleton: 'main-home-widget-loading-skeleton',

  // ─── Mobile Accordion ───
  mobileAccordion: 'main-home-widget-mobile-accordion',
  mobileAccordionManage: 'main-home-widget-mobile-accordion-manage',
  mobileAccordionCheckin: 'main-home-widget-mobile-accordion-checkin',
  mobileAccordionStatus: 'main-home-widget-mobile-accordion-status',
} as const;
